<!-- Banner Background -->
<!-- [style.background-image]="slidesData[0]?.bannerUrl ? 'url(' + slidesData[0].bannerUrl + ')' : 'none'" -->
<section [style.background-image]="slidesData[0]?.bannerUrl
    ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(48, 97, 226, 0.6) 200%), url(' + slidesData[0].bannerUrl + ')'
    : 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(48, 97, 226, 0.6) 200%)'"
  style="background-size: cover; background-position: center; background-repeat: no-repeat;"
  class="header-filter collection-banner text-center">
  <div class="container header">
    <div class="row py-lg-5">
      <div class="col-lg-8 col-md-8 mx-auto">
        <h1 class="fs-2 text-white fw-semi">Discover Collections</h1>

        <p class="text-white lead mb-4">
          Ready to use illustrations for your landing pages, apps, or presentations
        </p>
        <form class="col-lg-10 mx-auto d-flex search-form">
          <!-- show-mobile-view-search -->
          <div class="rounded-3 ps-2 pe-2 show-small-screen-search input-group input-group-lg">
            <input type="search" class="ft-size boxz form-control" placeholder="Search all collections"
              aria-label="Recipient's username" aria-describedby="button-addon2" [formControl]="typeahead"
              (keyup.enter)="navigateTo()" (input)="suggest()" />
            <a [routerLink]="['/search/']" [queryParams]="{ value: typeahead.value, searchKey: searchKey }" [class]="
                typeahead.value ? 'btn btn-ib-light' : 'btn btn-ib-light disable'
              " id="button-addon2">
              <i class="fas fa-search"></i>
            </a>
          </div>

          <!-- show-desktop-view-search -->
          <div class="rounded-3 ps-2 pe-2 show-lg-screen-search input-group input-group-lg">
            <!-- <button
              class="ft-size boxz btn res-btn border"
              type="button"
              aria-expanded="false"
            >
              Collections
            </button> -->

            <input type="search" class="ellipsis ft-size boxz form-control" placeholder="Search all collections"
              aria-label="Recipient's username" aria-describedby="button-addon2" [formControl]="typeahead"
              (input)="suggest()" (keyup.enter)="navigateTo()" />
            <a [routerLink]="['/search/']" [queryParams]="{ value: typeahead.value, searchKey: searchKey }"
              class="btn btn-ib-light" id="button-addon2" [class.disable]="!typeahead.value" [attr.aria-disabled]="!typeahead.value" aria-label="Search">
              <i class="fas fa-search" aria-hidden="true"></i>
            </a>
          </div>

          <div #autoSuggestion class="suggestions" [style.display]="
              suggestions?.length > 0 || typeahead?.value?.length > 0
                ? 'block'
                : 'none'
            " *ngIf="suggestions?.length > 0 || typeahead?.value?.length > 0">
            <span *ngIf="searchKey == 'Collections'">
              <a class="overflow-text" *ngFor="let s of suggestions" routerLink="/illustration-collection/{{ s.slug }}">
                <img [src]="getSEOImage(s.thumbUrl)" alt="{{ s.collectionName }}" class="skeleton--thumbnial" />
                {{ s.collectionName }}
              </a></span>
            <span *ngIf="
                suggestions &&
                suggestions?.length == 0 &&
                typeahead &&
                typeahead?.value?.length > 0
              " [style.display]="
                suggestions &&
                suggestions.length == 0 &&
                typeahead &&
                typeahead.value.length > 0
                  ? 'block'
                  : 'none'
              ">
              <a>No data found</a>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<section class="py-4">
  <!-- content -->
  <div class="spinner-back" *ngIf="loader">
    <div class="d-flex justify-content-center spinner-div">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>

  <section *ngIf="exclusiveData.length > 0">
    <div class="py-4 container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">
            Exclusive Collections
          </h2>
          <div class="browse-all" *ngIf="exclusiveData.length > 3">
            <a routerLink="/exclusive-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of exclusiveData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="getSEOImage(data?.thumbUrl)" [routerLink]="'/illustration-collection/' + data.slug">
              <div class="card collection-radius">
                <!-- data.thumbUrl  -->
                <img [src]="getSEOImage(data?.thumbUrl)" class="img-fluid rounded-top skeleton--image " [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>

        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="exclusiveData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px;" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found">
            <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
            <p class="mb-4 text-dark">
              We couldn't load the illustration at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="popularData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Popular Collections</h2>
          <div class="browse-all" *ngIf="popularData.length > 3">
            <a routerLink="/popular-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of popularData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="getSEOImage(data?.thumbUrl)" [routerLink]="'/illustration-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="getSEOImage(data?.thumbUrl)" class="img-fluid rounded-top skeleton--image " [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>

        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="popularData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px;" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found">
            <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
            <p class="mb-4 text-dark">
              We couldn't load the illustration at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="latestData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Latest Collections</h2>
          <div class="browse-all" *ngIf="latestData.length > 3">
            <a routerLink="/latest-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of latestData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="getSEOImage(data?.thumbUrl)" [routerLink]="'/illustration-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="getSEOImage(data?.thumbUrl)" class="img-fluid rounded-top skeleton--image " [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>
        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="latestData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px;" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found">
            <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
            <p class="mb-4 text-dark">
              We couldn't load the illustration at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="featuredData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Featured Collections</h2>
          <div class="browse-all" *ngIf="featuredData.length > 3">
            <a routerLink="/featured-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of featuredData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="getSEOImage(data?.thumbUrl)" [routerLink]="'/illustration-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="getSEOImage(data?.thumbUrl)" class="img-fluid rounded-top skeleton--image " [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>

        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="featuredData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px;" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found">
            <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
            <p class="mb-4 text-dark">
              We couldn't load the illustration at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="othersData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Other Collections</h2>
          <div class="browse-all" *ngIf="othersData.length > 3">
            <a routerLink="/other-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of othersData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="getSEOImage(data?.thumbUrl)" [routerLink]="'/illustration-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="getSEOImage(data?.thumbUrl)" class="img-fluid rounded-top skeleton--image " [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>

        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="othersData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px;" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found">
            <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
            <p class="mb-4 text-dark">
              We couldn't load the illustration at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="
      othersData.length == 0 &&
      latestData.length == 0 &&
      featuredData.length == 0 &&
      exclusiveData.length == 0 &&
      popularData.length == 0
    ">
    <div class="container">
      <div class="row row-cols-lg-5 py-3">
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="!loader">
          <div class="container">
            <img style="height: 200px;" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found">
            <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
            <p class="mb-4 text-dark">
              We couldn't load the illustration at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>